export default "__VITE_ASSET__DwmhkGB5__"